export const POST_LOGIN_REDIRECT_KEY = 'post_login_redirect_url';

export const setPostLoginRedirect = (url: string) =>
{
	localStorage.setItem(POST_LOGIN_REDIRECT_KEY, url);
};

export const popPostLoginRedirect = (): string | null =>
{
	const url = localStorage.getItem(POST_LOGIN_REDIRECT_KEY);
	if (url)
	{
		localStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
	}
	return url;
};